import { WppIconBoard, WppListItem, WppTag } from '@platform-ui-kit/components-library-react'
import { PropsWithChildren, useEffect, useRef } from 'react'

import styles from 'pages/files/sidePanel/SidePanel.module.scss'

interface Props extends PropsWithChildren {
  onClick?: () => void
  checked?: boolean
  selected?: boolean
  isInactive?: boolean
  'data-testid'?: string
}

export const HubItem = ({ children, onClick, checked, selected, isInactive, 'data-testid': dataTestId }: Props) => {
  const ref = useRef<HTMLWppListItemElement>(null)

  useEffect(() => {
    if (selected) {
      setTimeout(() => ref.current?.scrollIntoView(), 300)
    }
  }, [selected])

  return (
    <WppListItem checked={checked} onClick={onClick} className={styles.listItem} ref={ref} data-testid={dataTestId}>
      <p slot="label">{children}</p>
      <WppIconBoard slot="left" />
      {isInactive && <WppTag data-testid="file-details-ai-tag" label="inactive" variant="negative" slot="right" />}
    </WppListItem>
  )
}
